import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We're a volunteer-run study group for all things programming. Heavy emphasis on all things.`}</p>
    <p>{`Our goal is to learn all things coding together, and that is in the loosest sense of the word. Be it through projects, challenges, or even just having a chat, the aim is to learn!`}</p>
    <h1>{`That sounds fun! What programming language do you do?`}</h1>
    <p>{`Whichever you like. We mean it! The whole point of `}<em parentName="p">{`Study Jams`}</em>{` is to explore
`}<strong parentName="p">{`all things programming`}</strong>{`. That includes the programming language you're
wondering about.`}</p>
    <h1>{`Hey, but I have no idea what I could contribute...`}</h1>
    <p>{`Let me stop you there. That's totally fine! The whole point of a study group is
to learn together, meaning there's always something to do!`}</p>
    <p>{`Maybe you've:`}</p>
    <ul>
      <li parentName="ul">{`Got something you'd like to do a little `}<strong parentName="li">{`show & tell`}</strong>{`.`}</li>
      <li parentName="ul">{`Read about something interesting and want to share it.`}</li>
      <li parentName="ul">{`Heard so much about `}<inlineCode parentName="li">{`<insert technology here>`}</inlineCode>{` and want to try it out.`}</li>
      <li parentName="ul">{`Been stuck on an issue for `}<em parentName="li">{`ages`}</em>{` and want a hand.`}</li>
      <li parentName="ul">{`Got a talk recommendation.`}</li>
    </ul>
    <p>{`This is only the beginning! Maybe you've got a different reason for coming along!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      